import React from "react";
import  '../component/css/nwb.css';

const url = window.location.href;
// const url = "ulsterbank";
// const url = "rbs";
// const url = "natwest";
let brand ="rbs";
if (url.includes("ulsterbank")){
    brand = "ubn";
}
else if (url.includes("natwest")){
    brand = "nwb";
}
const Header = () =>{ return (

<div className="logobar">

{
                (() => {
                    if(brand==='nwb') {
                            return (
                                <div className="logo">
                                    <head>
                                        <title>
                                        NatWest - Online Repayment Service - Account Details
                                        </title>
                                    </head>
                                <img id="imgLogo" src="images/NW_Secondary_Horizontal_RGB_NEG.png" alt="NatWest Logo"
                                // style={{ borderWidth: 0 }}
                                />
                                </div>
                            )
                        }
                        else if(brand==='ubn') {
                            return (
                                <div className="logo">
                                <img id="imgLogo" src="images/UB_Horizontal_RGB_NEG.png" alt="NatWest Logo"
                                // style={{ borderWidth: 0 }}
                                />
                                </div>
                            )
                        }
                        
                        else {
                            return (
                                <div className="logorbs">
                                    <head>
                                        <title>
                                        Royal Bank of Scotland - Online Repayment Service - Account Details
                                        </title>
                                    </head>
                                <img id="imgLogo" src="images/RB_Horizontal_Stacked_RGB_NEG.png" alt="NatWest Logo"
                                // style={{ borderWidth: 0 }}
                                />
                                </div>
                            )
                        }
                })()  
            }  
    
</div>
)
}

export default Header;